var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "competition-edit" },
    [
      !_vm.ready
        ? _c("div", { staticClass: "row mat32" }, [_vm._m(0)])
        : [
            _vm.submitSuccess
              ? _c("panel-info-box", [
                  _c("img", {
                    staticStyle: { "max-height": "48px" },
                    attrs: {
                      src: require("../assets/images/icons/checkmark-circle.svg"),
                    },
                  }),
                  _c("p", { staticClass: "text-lg" }, [
                    _c("b", [_vm._v("Dane zostały poprawnie zapisane")]),
                  ]),
                ])
              : _vm._e(),
            _c("panel-competition-register-form", {
              attrs: {
                inputs: _vm.inputs,
                anonymous: _vm.anonymous,
                classifications: _vm.classificationList,
                saving: _vm.saving,
              },
              on: {
                "update:inputs": function ($event) {
                  _vm.inputs = $event
                },
                "update:anonymous": function ($event) {
                  _vm.anonymous = $event
                },
                add: _vm.addInput,
                remove: _vm.removeInput,
                copy: _vm.copyInput,
                "move-up": _vm.moveUp,
                "move-down": _vm.moveDown,
                save: _vm.save,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "admin-header__loading-state" }, [
        _vm._v(" Trwa wczytywanie "),
        _c("div", { staticClass: "mal15 lds-ellipsis" }, [
          _c("div"),
          _c("div"),
          _c("div"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }